import { programming as P } from '../definitions';

export const getProgramming = payload => {
  return {
    type: P.GET_PROGRAMMING_REQUESTED,
    payload,
  };
};